import { useNavigate } from 'react-router-dom';
import { MessageCircle, Phone } from 'lucide-react';
import { FeaturedListings } from './FeaturedListings';
import { RecentlyViewedVehicles } from './RecentlyViewedVehicles';
import { HomeServicesSection } from './HomeServicesSection';
import { AppDownloadSection } from './AppDownloadSection';
import { hasAppStoreLink } from '@/lib/appStoreLinks';
import './services.css';

interface HomeShowcaseProps {
  vehicles: any[];
  config: any;
  store: any;
}

const PRICE_RANGES = [
  { label: 'Até R$ 50 mil', min: 0, max: 50000 },
  { label: 'R$ 50 mil – R$ 100 mil', min: 50000, max: 100000 },
  { label: 'R$ 100 mil – R$ 200 mil', min: 100000, max: 200000 },
  { label: 'Acima de R$ 200 mil', min: 200000, max: 99999999 },
];

export function HomeShowcase({ vehicles, config, store }: HomeShowcaseProps) {
  const navigate = useNavigate();

  const contactImage = store?.frontage;
  const hasAppLinks =
    hasAppStoreLink(config.appStore) || !!config.googlePlay?.url?.trim();

  return (
    <>
      <FeaturedListings vehicles={vehicles} store={store} />

      <RecentlyViewedVehicles config={config} />

      <HomeServicesSection store={store} config={config} />

      <AppDownloadSection config={config} />

      {/* Contato */}
      <section className={`wl6-contact-block${hasAppLinks ? ' wl6-contact-block--muted' : ''}`}>
        <div className="wl6-container">
          <div className="wl6-contact-block-inner">
            {contactImage && (
              <div className="wl6-contact-block-media">
                <img src={contactImage} alt={`Equipe ${config.name}`} loading="lazy" />
              </div>
            )}
            <div className="wl6-contact-block-body">
              <p className="wl6-eyebrow">Suporte</p>
              <h2>Tem alguma dúvida? Fale conosco</h2>
              <p className="wl6-lead text-sm mt-2">
                Nossa equipe está pronta para ajudar você a encontrar o veículo perfeito.
              </p>
              <div className="wl6-contact-block-actions">
                <button
                  type="button"
                  className="wl6-contact-btn wl6-contact-btn--primary"
                  onClick={() => navigate('/contato')}
                >
                  <MessageCircle className="h-4 w-4" />
                  Contato
                </button>
                {store.phone?.ios && (
                  <a href={store.phone.ios} className="wl6-contact-btn wl6-contact-btn--outline">
                    <Phone className="h-4 w-4" />
                    {store.phone.formatted}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export { PRICE_RANGES };
